'use strict';exports.__esModule = true;exports.canCreateStaff = exports.clearUserAuthentication = exports.loginWithEdit = exports.clearAuthError = exports.authenticateWithCode = exports.updateUserFavorites = exports.updateVerification = exports.getAgencyInfo = exports.switchAuthModalType = exports.socialNetworkAuthentication = exports.changePassword = exports.updatePassword = exports.verifyToken = exports.authUserByToken = exports.editUserProfile = exports.hideAuthenticationModal = exports.openAuthenticationModal = exports.authenticateUserByNumber = exports.checkPhone = exports.completeRegistration = exports.initRegistration = exports.authenticateUser = exports.sendEmail = exports.logOut = exports.addSavedDataToStore = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _sha = require('sha256');var _sha2 = _interopRequireDefault(_sha);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _constants = require('../../constants');





var _cookiesManage = require('../../utils/cookiesManage');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var addSavedDataToStore = (0, _reduxAct.createAction)('/ADD_SAVED_DATA_TO_STORE');
var sendEmail = (0, _reduxAct.createAction)('/SEND_EMAIL');
var sendEmailSuccess = (0, _reduxAct.createAction)('/SEND_EMAIL_SUCCESS');
var sendEmailFail = (0, _reduxAct.createAction)('/SEND_EMAIL_FAIL');
var openAuthenticationModal = (0, _reduxAct.createAction)('/OPEN_AUTHENTICATE_MODAL');
var hideAuthenticationModal = (0, _reduxAct.createAction)('/HIDE_AUTHENTICATE_MODAL');
var logOut = (0, _reduxAct.createAction)('/LOG_OUT');
var authenticateUser = (0, _reduxAct.createAction)('/AUTHENTICATE_USER');
var authenticateUserSuccess = (0, _reduxAct.createAction)('/AUTHENTICATE_USER_SUCCESS');
var authenticateUserFail = (0, _reduxAct.createAction)('/AUTHENTICATE_USER_FAIL');
var authenticateUserByNumber = (0, _reduxAct.createAction)('/AUTHENTICATE_USER_BY_NUMBER');
var authenticateUserByNumberFail = (0, _reduxAct.createAction)('/AUTHENTICATE_USER_BY_NUMBER_FAIL');
var checkPhone = (0, _reduxAct.createAction)('/CHECK_PHONE');
var checkPhoneSuccess = (0, _reduxAct.createAction)('/CHECK_PHONE_SUCCESS');
var checkPhoneFail = (0, _reduxAct.createAction)('/CHECK_PHONE_FAIL');
var editUserProfile = (0, _reduxAct.createAction)('/EDIT_USER_PROFILE');
var editUserProfileSuccess = (0, _reduxAct.createAction)('/EDIT_USER_PROFILE_SUCCESS');
var editUserProfileFail = (0, _reduxAct.createAction)('/EDIT_USER_PROFILE_FAIL');
var authUserByToken = (0, _reduxAct.createAction)('/AUTH_USER_BY_TOKEN');
var authUserByTokenSuccess = (0, _reduxAct.createAction)('/AUTH_USER_BY_TOKEN_SUCCESS');
var authUserByTokenFail = (0, _reduxAct.createAction)('/AUTH_USER_BY_TOKEN_FAIL');
var canCreateStaff = (0, _reduxAct.createAction)('/CAN_CREATE_STAFF');
var canCreateStaffSuccess = (0, _reduxAct.createAction)('/CAN_CREATE_STAFF_SUCCESS');
var canCreateStaffFail = (0, _reduxAct.createAction)('/CAN_CREATE_STAFF_FAIL');
var verifyToken = (0, _reduxAct.createAction)('/VERIFY_TOKEN');
var verifyTokenSuccess = (0, _reduxAct.createAction)('/VERIFY_TOKEN_SUCCESS');
var verifyTokenFail = (0, _reduxAct.createAction)('/VERIFY_TOKEN_FAIL');
var updatePassword = (0, _reduxAct.createAction)('/UPDATE_PASSWORD');
var updatePasswordSuccess = (0, _reduxAct.createAction)('/UPDATE_PASSWORD_SUCCESS');
var updatePasswordFail = (0, _reduxAct.createAction)('/UPDATE_PASSWORD_FAIL');
var changePassword = (0, _reduxAct.createAction)('/CHANGE_PASSWORD');
var changePasswordSuccess = (0, _reduxAct.createAction)('/CHANGE_PASSWORD_SUCCESS');
var changePasswordFail = (0, _reduxAct.createAction)('/CHANGE_PASSWORD_FAIL');
var socialNetworkAuthentication = (0, _reduxAct.createAction)('/SOCIAL_NETWORK_AUTHENTICATION');
var socialNetworkAuthenticationSuccess = (0, _reduxAct.createAction)('/SOCIAL_NETWORK_AUTHENTICATION_SUCCESS');
var socialNetworkAuthenticationFail = (0, _reduxAct.createAction)('/SOCIAL_NETWORK_AUTHENTICATION_FAIL');
var switchAuthModalType = (0, _reduxAct.createAction)('/SWITCH_AUTHENTICATION_MODAL_TYPE');
var updateVerification = (0, _reduxAct.createAction)('/UPDATE_VERIFICATION');
var updateUserFavorites = (0, _reduxAct.createAction)('/UPDATE_USER_FAVORITES');
var authenticateWithCode = (0, _reduxAct.createAction)('/AUTH_WITH_CODE');
var authenticateWithCodeSuccess = (0, _reduxAct.createAction)('/AUTH_WITH_CODE_SUCCESS');
var authenticateWithCodeFail = (0, _reduxAct.createAction)('/AUTH_WITH_CODE_FAIL');
var clearAuthError = (0, _reduxAct.createAction)('/CLEAR_AUTH_ERROR');
var clearUserAuthentication = (0, _reduxAct.createAction)('/CLEAR_USER_AUTH');
var loginWithEdit = (0, _reduxAct.createAction)('/LOGIN_WITH_EDIT');

var initRegistration = (0, _reduxAct.createAction)('/INIT_REGISTRATION');
var initRegistrationSuccess = (0, _reduxAct.createAction)('/INIT_REGISTRATION_SUCCESS');
var initRegistrationFail = (0, _reduxAct.createAction)('/INIT_REGISTRATION_FAIL');

var completeRegistration = (0, _reduxAct.createAction)('/COMPLETE_REGISTRATION');
var completeRegistrationSuccess = (0, _reduxAct.createAction)('/COMPLETE_REGISTRATION_SUCCESS');
var completeRegistrationFail = (0, _reduxAct.createAction)('/COMPLETE_REGISTRATION_FAIL');

var resendRegistrationCode = (0, _reduxAct.createAction)('/RESEND_REGISTRATION_CODE');
var resendRegistrationCodeSuccess = (0, _reduxAct.createAction)('/RESEND_REGISTRATION_CODE_SUCCESS');
var resendRegistrationCodeFail = (0, _reduxAct.createAction)('/RESEND_REGISTRATION_CODE_FAIL');

var getAgencyInfo = (0, _reduxAct.createAction)('/GET_AGENCY_INFO');
var getAgencyInfoSuccess = (0, _reduxAct.createAction)('/GET_AGENCY_INFO_SUCCESS');
var getAgencyInfoFail = (0, _reduxAct.createAction)('/GET_AGENCY_INFO_FAIL');

var formatUpdateProfileDto = function formatUpdateProfileDto(values) {
  var cleanUserData = (0, _pick2.default)(values, [
  'email',
  'is_agent',
  'first_name',
  'last_name',
  'profile_img',
  'phone_number',
  'display_name',
  'staff_info',
  'agent_data']);


  if (cleanUserData.staff_info) {
    cleanUserData.staff_info = (0, _pick2.default)(cleanUserData.staff_info, [
    'description',
    'phone']);

  } else {
    cleanUserData.staff_info = undefined;
  }

  if (cleanUserData.agent_data) {
    cleanUserData.agent_data = (0, _pick2.default)(cleanUserData.agent_data, [
    'name',
    'title',
    'description',
    'phone_number',
    'email',
    'company_name',
    'license_number',
    'licensed_since']);

  }
  return cleanUserData;
};

var initialState = {
  isAuthenticationModalOpen: false,
  authenticationModalType: _constants.authenticationModalType.DEFAULT,
  userIsAuthorized: false,
  selectedTab: _constants.userAuthenticationTabs.SIGN_IN,
  emailSent: false,
  loading: false,
  loaded: false,
  isCheckPhone: false,
  isRegistrationCheckPhone: false,
  errorCheckPhone: false,
  errorPhoneCode: false,
  isCanCreateStaff: false,
  edited: null,
  agencyInfo: null,
  accessToken: null };


var fetchSendEmail = function fetchSendEmail(_ref) {var email = _ref.email,locale = _ref.locale;return _axios2.default.
  post('/users/password/forgot', { email: email.toLowerCase(), locale: locale }).
  then(sendEmailSuccess, sendEmailFail);};

var fetchCompleteRegistration =
function fetchCompleteRegistration(_ref2) {var
  email = _ref2.email,
  password = _ref2.password,
  captcha = _ref2.captcha,
  phone = _ref2.phone,
  first_name = _ref2.first_name,
  last_name = _ref2.last_name,
  is_agent = _ref2.is_agent,
  license_number = _ref2.license_number,
  company_name = _ref2.company_name,
  profile_img = _ref2.profile_img,
  discount_code = _ref2.discount_code,
  code = _ref2.code;return (
    _axios2.default.
    post('/users/complete-registration', {
      email: email.trim().replace(/\s/g, '').toLowerCase(),
      password: (0, _sha2.default)(password),
      is_agent: is_agent,
      license_number: license_number,
      company_name: company_name || undefined,
      profile_img: !(0, _isEmpty2.default)(profile_img) ? profile_img : undefined,
      discount_code: !!discount_code ? discount_code : undefined,
      captcha: captcha,
      phone: (0, _formatPhoneNumber.normalizePhoneNumber)(phone),
      first_name: first_name,
      last_name: last_name,
      code: code }).


    then(completeRegistrationSuccess, completeRegistrationFail));};

var fetchInitRegistration =
function fetchInitRegistration(_ref3) {var
  email = _ref3.email,
  password = _ref3.password,
  captcha = _ref3.captcha,
  locale = _ref3.locale,
  phone = _ref3.phone,
  first_name = _ref3.first_name,
  last_name = _ref3.last_name,
  is_agent = _ref3.is_agent,
  license_number = _ref3.license_number,
  company_name = _ref3.company_name,
  profile_img = _ref3.profile_img,
  discount_code = _ref3.discount_code;return (
    _axios2.default.
    post('/users/init-registration', {
      email: email.trim().replace(/\s/g, '').toLowerCase(),
      password: (0, _sha2.default)(password),
      is_agent: is_agent,
      license_number: license_number,
      company_name: company_name || undefined,
      profile_img: !(0, _isEmpty2.default)(profile_img) ? profile_img : undefined,
      discount_code: !!discount_code ? discount_code : undefined,
      captcha: captcha,
      locale: locale,
      phone: (0, _formatPhoneNumber.normalizePhoneNumber)(phone),
      first_name: first_name,
      last_name: last_name }).


    then(initRegistrationSuccess, initRegistrationFail));};

var fetchResendRegistrationCode =
function fetchResendRegistrationCode(_ref4) {var
  captcha = _ref4.captcha,
  locale = _ref4.locale,
  phone = _ref4.phone;return (
    _axios2.default.
    post('/users/resend-registration-sms', {
      captcha: captcha,
      locale: locale,
      phone: (0, _formatPhoneNumber.normalizePhoneNumber)(phone) }).


    then(resendRegistrationCodeSuccess, resendRegistrationCodeFail));};

var fetchAuthentication =
function fetchAuthentication(_ref5) {var
  email = _ref5.email,
  password = _ref5.password,
  is_agent = _ref5.is_agent,
  license_number = _ref5.license_number,
  company_name = _ref5.company_name,
  requestType = _ref5.requestType,
  profile_img = _ref5.profile_img,
  discount_code = _ref5.discount_code,
  first_name = _ref5.first_name;return (
    _axios2.default.
    post('' + (requestType === _constants.userAuthenticationTabs.SIGN_IN ? '/login' : '/users'), {
      email: email.trim().replace(/\s/g, '').toLowerCase(),
      password: (0, _sha2.default)(password),
      is_agent: is_agent,
      license_number: license_number,
      company_name: company_name || undefined,
      profile_img: !(0, _isEmpty2.default)(profile_img) ? profile_img : undefined,
      discount_code: !!discount_code ? discount_code : undefined,
      first_name: requestType === _constants.userAuthenticationTabs.NEW_ACCOUNT ? first_name : undefined }).


    then(authenticateUserSuccess, authenticateUserFail));};

var fetchCheckPhone = function fetchCheckPhone(_ref6) {var captcha = _ref6.captcha,phone = _ref6.phone,locale = _ref6.locale;return (
    _axios2.default.post('users/login-phone', {
      captcha: captcha,
      phone: (0, _formatPhoneNumber.normalizePhoneNumber)(phone),
      locale: locale }).
    then(checkPhoneSuccess, checkPhoneFail));};

var authenticateUserByNumberFailHandler = function authenticateUserByNumberFailHandler(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to authenticate');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    errorPhoneCode: true,
    data: null,
    error: error });

};

var fetchAuthenticationByNumber = function fetchAuthenticationByNumber(_ref7) {var phone = _ref7.phone,code = _ref7.code,captcha = _ref7.captcha;return (
    _axios2.default.post('users/login-phone-code', { phone: phone, code: code, captcha: captcha }).
    then(authenticateUserSuccess, authenticateUserByNumberFail));};

var fetchLoginWithEdit = function fetchLoginWithEdit(_ref8) {var email = _ref8.email,password = _ref8.password,is_agent = _ref8.is_agent,license_number = _ref8.license_number,company_name = _ref8.company_name;return _axios2.default.
  post('/login', {
    email: email.trim().replace(/\s/g, '').toLowerCase(),
    password: (0, _sha2.default)(password) }).


  then(function (response) {
    var userToken = (0, _get2.default)(response, 'data.access_token');
    var data = {
      agent_data: {
        license_number: license_number,
        company_name: company_name },

      is_agent: is_agent };


    return _axios2.default.put('/users/me', data, { headers: { access_token: userToken } });
  }).
  then(authenticateUserSuccess, authenticateUserFail);};

var fetchEditProfileRequest = function fetchEditProfileRequest(_ref9) {var userData = _ref9.userData,userToken = _ref9.userToken,partialUpdate = _ref9.partialUpdate;
  var cleanUserData = formatUpdateProfileDto(userData);
  var data = !!partialUpdate ? Object.assign({},
  cleanUserData, partialUpdate) :
  cleanUserData;

  return _axios2.default.
  put('/users/me', data, { headers: { access_token: userToken } }).
  then(editUserProfileSuccess, editUserProfileFail);
};

var fetchAuthUserByTokenRequest = function fetchAuthUserByTokenRequest(userToken) {return _axios2.default.
  get('/users/me', { headers: { access_token: userToken } }).
  then(authUserByTokenSuccess, authUserByTokenFail);};

var canCreateStaffRequest = function canCreateStaffRequest(userToken) {return _axios2.default.
  get('/users/can_create_staff', { headers: { access_token: userToken } }).
  then(canCreateStaffSuccess, canCreateStaffFail);};

var fetchVerifyToken = function fetchVerifyToken(token) {return _axios2.default.
  post('/users/password/verify_token', { token: token }).
  then(verifyTokenSuccess, verifyTokenFail);};

var fetchUpdatePassword = function fetchUpdatePassword(_ref10) {var password = _ref10.password,token = _ref10.token;return _axios2.default.
  post('/users/password/reset', { password: (0, _sha2.default)(password), token: token }).
  then(updatePasswordSuccess, updatePasswordFail);};

var fetchAuthWithCode = function fetchAuthWithCode(code) {return _axios2.default.
  post('/users/login_code/verify', { code: code }).
  then(authenticateWithCodeSuccess, authenticateWithCodeFail);};

var fetchGetAgencyInfo = function fetchGetAgencyInfo(userToken) {return _axios2.default.
  get('/users/agency-info', { headers: { access_token: userToken } }).
  then(getAgencyInfoSuccess, getAgencyInfoFail);};

var fetchSocialNetworkAuthentication = function fetchSocialNetworkAuthentication(_ref11) {var network = _ref11.network,data = _ref11.data,_ref11$config = _ref11.config,config = _ref11$config === undefined ? {} : _ref11$config;
  var url = '/' + network;
  return _axios2.default.post(url, data, config).
  then(socialNetworkAuthenticationSuccess, socialNetworkAuthenticationFail);
};

var fetchChangePassword = function fetchChangePassword(_ref12) {var access_token = _ref12.access_token,new_password = _ref12.new_password,old_password = _ref12.current_password;return _axios2.default.
  post('/users/password/change', {
    old_password: (0, _sha2.default)(old_password),
    new_password: (0, _sha2.default)(new_password) },
  { headers: { access_token: access_token } }).
  then(changePasswordSuccess, changePasswordFail);};

var editProfileHandler = function editProfileHandler(state, userData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null,
    editing: true,
    edited: false }),
  promise(fetchEditProfileRequest, userData));};

var authUserByTokenHandler = function authUserByTokenHandler(state, token) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null,
    loaded: false }),
  promise(fetchAuthUserByTokenRequest, token));};

var canCreateStaffHandler = function canCreateStaffHandler(state, token) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null,
    loaded: false }),
  promise(canCreateStaffRequest, token));};

var initRegistrationHandler = function initRegistrationHandler(state, userData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    isRegistrationCheckPhone: false,
    error: null }),
  promise(fetchInitRegistration, userData));};

var completeRegistrationHandler = function completeRegistrationHandler(state, userData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchCompleteRegistration, userData));};

var resendRegistrationCodeHandler = function resendRegistrationCodeHandler(state, userData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchResendRegistrationCode, userData));};

var authenticationHandler = function authenticationHandler(state, userData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchAuthentication, userData));};

var checkPhoneHandler = function checkPhoneHandler(state, userData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchCheckPhone, userData));};

var authenticationByNumberHandler = function authenticationByNumberHandler(state, userData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchAuthenticationByNumber, userData));};

var handleLoginWithEdit = function handleLoginWithEdit(state, userData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchLoginWithEdit, userData));};

var verifyTokenHandler = function verifyTokenHandler(state, token) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchVerifyToken, token));};

var updatePasswordHandler = function updatePasswordHandler(state, password, token) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchUpdatePassword, password, token));};

var changePasswordHandler = function changePasswordHandler(state, value) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null,
    edited: false }),
  promise(fetchChangePassword, value));};

var sendEmailHandler = function sendEmailHandler(state, userData) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchSendEmail, userData));};

var socialNetworkAuthenticationHandler = function socialNetworkAuthenticationHandler(state, _ref13) {var network = _ref13.network,data = _ref13.data,config = _ref13.config;return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchSocialNetworkAuthentication, { network: network, data: data, config: config }));};

var addSavedDataToStoreHandler = function addSavedDataToStoreHandler(state, action) {return Object.assign({},
  state, {
    data: action,
    userIsAuthorized: true });};


var authenticateWithCodeHandler = function authenticateWithCodeHandler(state, code) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchAuthWithCode, code));};

var getAgencyInfoHandler = function getAgencyInfoHandler(state, code) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true,
    error: null }),
  promise(fetchGetAgencyInfo, code));};

var changePasswordHandlerSuccess = function changePasswordHandlerSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: Object.assign({},
    action.data, {
      access_token: action.data.access_token || state.data.access_token }),

    authenticationModalType: _constants.authenticationModalType.PASSWORD_CHANGED });};


var changePasswordHandlerFail = function changePasswordHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to change password');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    authenticationModalType: _constants.authenticationModalType.PASSWORD_CHANGE_FAILED,
    error: error });

};

var clearUserAuthenticationHandler = function clearUserAuthenticationHandler(state) {return Object.assign({},
  state, {
    loading: false,
    isCheckPhone: false,
    errorCheckPhone: false,
    error: null,
    errorPhoneCode: false });};


var updatePasswordHandlerSuccess = function updatePasswordHandlerSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    userIsAuthorized: true,
    data: action.data.access_token ? action.data : Object.assign({}, action.data, { access_token: state.data.access_token }),
    authenticationModalType: _constants.authenticationModalType.PASSWORD_UPDATED });};


var updatePasswordHandlerFail = function updatePasswordHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to update password');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    authenticationModalType: _constants.authenticationModalType.PASSWORD_UPDATE_FAILED,
    error: error });

};

var verifyTokenHandlerSuccess = function verifyTokenHandlerSuccess(state) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    tokenIsValid: true });};


var verifyTokenHandlerFail = function verifyTokenHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to verify token');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    tokenIsValid: false,
    authenticationModalType: _constants.authenticationModalType.TOKEN_INVALID,
    error: action });

};

var logOutHandler = function logOutHandler(state) {
  (0, _cookiesManage.deleteCookie)('accessToken');
  _constants.storage.value.clear();

  return Object.assign({},
  state,
  initialState, {
    userIsAuthorized: false,
    data: null,
    accessToken: null });

};

var authenticationHandlerSuccess = function authenticationHandlerSuccess(state, action) {
  var secure = process.env.NODE_ENV && process.env.NODE_ENV !== 'development';

  (0, _cookiesManage.setCookie)('accessToken', action.data.access_token, { expires: 500000, path: '/', secure: secure });
  _constants.storage.value.setItem('userData', JSON.stringify(action.data));
  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    errorPhoneCode: false,
    userIsAuthorized: true,
    data: action.data.access_token ? action.data : Object.assign({}, action.data, { access_token: state.data.access_token }),
    error: null });

};

var authenticationHandlerFail = function authenticationHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to authenticate');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    errorCheckPhone: false,
    errorPhoneCode: false,
    data: null,
    error: error });

};

var completeRegistrationHandlerSuccess = function completeRegistrationHandlerSuccess(state, action) {
  var secure = process.env.NODE_ENV && process.env.NODE_ENV !== 'development';

  (0, _cookiesManage.setCookie)('accessToken', action.data.access_token, { expires: 500000, path: '/', secure: secure });
  _constants.storage.value.setItem('userData', JSON.stringify(action.data));
  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    errorPhoneCode: false,
    isRegistrationCheckPhone: false,
    userIsAuthorized: true,
    data: action.data.access_token ? action.data : Object.assign({}, action.data, { access_token: state.data.access_token }),
    error: null });

};

var completeRegistrationHandlerFail = function completeRegistrationHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to authenticate');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    errorCheckPhone: false,
    errorPhoneCode: false,
    data: null,
    error: error });

};

var initRegistrationHandlerSuccess = function initRegistrationHandlerSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    errorPhoneCode: false,
    isRegistrationCheckPhone: true,
    error: null });};


var initRegistrationHandlerFail = function initRegistrationHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to authenticate');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    isRegistrationCheckPhone: false,
    error: error });

};

var resendRegistrationCodeHandlerSuccess = function resendRegistrationCodeHandlerSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    errorPhoneCode: false,
    isRegistrationCheckPhone: true,
    isResendRegistrationCode: true,
    error: null });};


var resendRegistrationCodeHandlerFail = function resendRegistrationCodeHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to authenticate');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    isRegistrationCheckPhone: false,
    isResendRegistrationCode: false,
    error: error });

};

var checkPhoneHandlerSuccess = function checkPhoneHandlerSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    isCheckPhone: true,
    errorCheckPhone: false });};


var checkPhoneHandlerFail = function checkPhoneHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to authenticate');

  return Object.assign({},
  state, {
    loading: false,
    isCheckPhone: false,
    errorCheckPhone: true,
    error: error });

};

var editProfileHandlerSuccess = function editProfileHandlerSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    editing: false,
    edited: true,
    data: action.data.access_token ? action.data : Object.assign({}, action.data, { access_token: state.data.access_token }),
    error: null,
    isAuthenticationModalOpen: false });};


var editProfileHandlerFail = function editProfileHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to edit profile');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    editing: false,
    edited: false,
    error: error });

};

var authUserByTokenHandlerSuccess = function authUserByTokenHandlerSuccess(state, action) {
  var token = state.accessToken || state.data && state.data.access_token;

  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    userIsAuthorized: true,
    data: Object.assign({}, state.data, action.data, { access_token: token }),
    error: null });

};

var authUserByTokenHandlerFail = function authUserByTokenHandlerFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to authenticate user by token');

  if (__CLIENT__) {
    return logOutHandler(state);
  }

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: state.data,
    error: action.data });

};

var canCreateStaffHandlerSuccess = function canCreateStaffHandlerSuccess(state, action) {return Object.assign({},
  state, {
    isCanCreateStaff: action.data,
    loading: false,
    loaded: true,
    error: null });};


var canCreateStaffHandlerFail = function canCreateStaffHandlerFail(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: action.data });};


var handleOpen = function handleOpen(state, action) {return Object.assign({},
  state, {
    isAuthenticationModalOpen: true,
    error: null,
    authenticationModalType: action.bodyType || _constants.authenticationModalType.DEFAULT,
    selectedTab: action.selectedTab || _constants.userAuthenticationTabs.SIGN_IN });};


var handleHide = function handleHide(state) {return Object.assign({},
  state, {
    isAuthenticationModalOpen: false,
    error: null,
    emailSent: false });};


var sendEmailHandlerSuccess = function sendEmailHandlerSuccess(state) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    emailSent: true,
    authenticationModalType: _constants.authenticationModalType.SEND_EMAIL_SUCCESS });};


var sendEmailHandlerFail = function sendEmailHandlerFail(state, action) {
  var modalType =
  action.response.data && action.response.data.status === 400 ?
  _constants.authenticationModalType.FORGOT_PASSWORD :
  _constants.authenticationModalType.SEND_EMAIL_FAIL;

  var error = (0, _formatApiError2.default)(action, 'Failed to send email');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    error: error,
    authenticationModalType: modalType });

};


var switchAuthModalTypeHandler = function switchAuthModalTypeHandler(state, action) {return Object.assign({},
  state, {
    authenticationModalType: action.bodyType,
    selectedTab: action.selectedTab || state.selectedTab });};


var updateVerificationHandler = function updateVerificationHandler(state, updatedVerification) {return Object.assign({},
  state, {
    data: Object.assign({},
    state.data, {
      verification: Object.assign({},
      state.data.verification,
      updatedVerification) }) });};




var updateUserFavoritesHandler = function updateUserFavoritesHandler(state, favorites) {
  var userData = Object.assign({},
  state.data, {
    properties: Object.assign({},
    state.data.properties, {
      favorites: favorites }) });


  _constants.storage.value.setItem('userData', JSON.stringify(userData));

  return Object.assign({},
  state, {
    data: userData });

};

var authenticateWithCodeSuccessHandler = function authenticateWithCodeSuccessHandler(state, action) {
  var secure = process.env.NODE_ENV && process.env.NODE_ENV !== 'development';

  (0, _cookiesManage.setCookie)('accessToken', action.data.access_token, { expires: 500000, path: '/', secure: secure });
  _constants.storage.value.setItem('userData', JSON.stringify(action.data));
  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    userIsAuthorized: true,
    data: action.data.access_token ? action.data : Object.assign({}, action.data, { access_token: state.data.access_token }),
    error: null });

};

var authenticateWithCodeFailHandler = function authenticateWithCodeFailHandler(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to authenticate with code');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var getAgencyInfoSuccessHandler = function getAgencyInfoSuccessHandler(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    agencyInfo: action.data });};


var getAgencyInfoFailHandler = function getAgencyInfoFailHandler(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed to authenticate with code');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    agencyInfo: null,
    error: error });

};

var handleClearError = function handleClearError(state) {return Object.assign({},
  state, {
    error: null });};


var userAuthentication = (0, _reduxAct.createReducer)(function (on) {
  on(addSavedDataToStore, addSavedDataToStoreHandler);
  on(sendEmail, sendEmailHandler);
  on(sendEmailSuccess, sendEmailHandlerSuccess);
  on(sendEmailFail, sendEmailHandlerFail);
  on(openAuthenticationModal, handleOpen);
  on(hideAuthenticationModal, handleHide);
  on(logOut, logOutHandler);
  on(checkPhone, checkPhoneHandler);
  on(checkPhoneSuccess, checkPhoneHandlerSuccess);
  on(checkPhoneFail, checkPhoneHandlerFail);
  on(authenticateUser, authenticationHandler);
  on(authenticateUserSuccess, authenticationHandlerSuccess);
  on(authenticateUserFail, authenticationHandlerFail);
  on(initRegistration, initRegistrationHandler);
  on(initRegistrationSuccess, initRegistrationHandlerSuccess);
  on(initRegistrationFail, initRegistrationHandlerFail);
  on(completeRegistration, completeRegistrationHandler);
  on(completeRegistrationSuccess, completeRegistrationHandlerSuccess);
  on(completeRegistrationFail, completeRegistrationHandlerFail);
  on(resendRegistrationCode, resendRegistrationCodeHandler);
  on(resendRegistrationCodeSuccess, resendRegistrationCodeHandlerSuccess);
  on(resendRegistrationCodeFail, resendRegistrationCodeHandlerFail);
  on(authenticateUserByNumber, authenticationByNumberHandler);
  on(authenticateUserByNumberFail, authenticateUserByNumberFailHandler);
  on(editUserProfile, editProfileHandler);
  on(editUserProfileSuccess, editProfileHandlerSuccess);
  on(editUserProfileFail, editProfileHandlerFail);
  on(authUserByToken, authUserByTokenHandler);
  on(authUserByTokenSuccess, authUserByTokenHandlerSuccess);
  on(authUserByTokenFail, authUserByTokenHandlerFail);
  on(canCreateStaff, canCreateStaffHandler);
  on(canCreateStaffSuccess, canCreateStaffHandlerSuccess);
  on(canCreateStaffFail, canCreateStaffHandlerFail);
  on(verifyToken, verifyTokenHandler);
  on(verifyTokenSuccess, verifyTokenHandlerSuccess);
  on(verifyTokenFail, verifyTokenHandlerFail);
  on(updatePassword, updatePasswordHandler);
  on(updatePasswordSuccess, updatePasswordHandlerSuccess);
  on(updatePasswordFail, updatePasswordHandlerFail);
  on(changePassword, changePasswordHandler);
  on(changePasswordSuccess, changePasswordHandlerSuccess);
  on(changePasswordFail, changePasswordHandlerFail);
  on(socialNetworkAuthentication, socialNetworkAuthenticationHandler);
  on(socialNetworkAuthenticationSuccess, authenticationHandlerSuccess);
  on(socialNetworkAuthenticationFail, authenticationHandlerFail);
  on(switchAuthModalType, switchAuthModalTypeHandler);
  on(updateVerification, updateVerificationHandler);
  on(updateUserFavorites, updateUserFavoritesHandler);
  on(authenticateWithCode, authenticateWithCodeHandler);
  on(authenticateWithCodeSuccess, authenticateWithCodeSuccessHandler);
  on(authenticateWithCodeFail, authenticateWithCodeFailHandler);
  on(getAgencyInfo, getAgencyInfoHandler);
  on(getAgencyInfoSuccess, getAgencyInfoSuccessHandler);
  on(getAgencyInfoFail, getAgencyInfoFailHandler);
  on(clearAuthError, handleClearError);
  on(loginWithEdit, handleLoginWithEdit);
  on(clearUserAuthentication, clearUserAuthenticationHandler);
}, initialState);exports.


addSavedDataToStore = addSavedDataToStore;exports.
logOut = logOut;exports.
sendEmail = sendEmail;exports.
authenticateUser = authenticateUser;exports.
initRegistration = initRegistration;exports.
completeRegistration = completeRegistration;exports.
checkPhone = checkPhone;exports.
authenticateUserByNumber = authenticateUserByNumber;exports.
openAuthenticationModal = openAuthenticationModal;exports.
hideAuthenticationModal = hideAuthenticationModal;exports.
editUserProfile = editUserProfile;exports.
authUserByToken = authUserByToken;exports.
verifyToken = verifyToken;exports.
updatePassword = updatePassword;exports.
changePassword = changePassword;exports.
socialNetworkAuthentication = socialNetworkAuthentication;exports.
switchAuthModalType = switchAuthModalType;exports.
getAgencyInfo = getAgencyInfo;exports.
updateVerification = updateVerification;exports.
updateUserFavorites = updateUserFavorites;exports.
authenticateWithCode = authenticateWithCode;exports.
clearAuthError = clearAuthError;exports.
loginWithEdit = loginWithEdit;exports.
clearUserAuthentication = clearUserAuthentication;exports.
canCreateStaff = canCreateStaff;exports.default =


userAuthentication;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/userAuthentication.js
// module id = 55
// module chunks = 0